module.exports = __webpack_public_path__ + "img/36_65.0a4ef902.png";